import { supabase } from "./supabase";

class AIGenerationsService {
  // Get user's generation history
  async getGenerations(userId, limit = 10) {
    try {
      const { data, error } = await supabase
        .from("ai_generations")
        .select("*")
        .eq("user_id", userId)
        .order("created_at", { ascending: false })
        .limit(limit);

      if (error) throw error;
      console.log("✅ Generations fetched:", data?.length || 0, "items");
      return data || [];
    } catch (error) {
      console.error("❌ Failed to fetch generations:", error);
      return [];
    }
  }

  // Save a new generation
  async saveGeneration(userId, searchData, resultsData) {
    try {
      console.log("💾 Saving generation for user:", userId);
      console.log("📝 Search data:", searchData);
      console.log("📦 Results count:", resultsData.length);

      const { data, error } = await supabase
        .from("ai_generations")
        .insert({
          user_id: userId,
          search_query: searchData.query,
          occasions: searchData.occasions || [],
          relationships: searchData.relationships || [],
          age_groups: searchData.age_groups || [],
          personality: searchData.personality || [],
          results_count: resultsData.length,
          results: resultsData.slice(0, 10), // Save top 10 results
        })
        .select()
        .single();

      if (error) {
        console.error("❌ Error saving generation:", error);
        throw error;
      }

      console.log("✅ Generation saved successfully:", data.id);
      return data;
    } catch (error) {
      console.error("❌ Failed to save generation:", error);
      return null;
    }
  }

  // Delete a generation
  async deleteGeneration(userId, generationId) {
    try {
      const { error } = await supabase
        .from("ai_generations")
        .delete()
        .eq("id", generationId)
        .eq("user_id", userId); // Security: only delete own generations

      if (error) throw error;
      console.log("✅ Generation deleted:", generationId);
      return true;
    } catch (error) {
      console.error("❌ Error deleting generation:", error);
      return false;
    }
  }

  // Clear all generations for a user
  async clearAllGenerations(userId) {
    try {
      const { error } = await supabase
        .from("ai_generations")
        .delete()
        .eq("user_id", userId);

      if (error) throw error;
      console.log("✅ All generations cleared for user:", userId);
      return true;
    } catch (error) {
      console.error("❌ Error clearing generations:", error);
      return false;
    }
  }

  // Get generation details by ID
  async getGenerationById(userId, generationId) {
    try {
      const { data, error } = await supabase
        .from("ai_generations")
        .select("*")
        .eq("id", generationId)
        .eq("user_id", userId)
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("❌ Error fetching generation:", error);
      return null;
    }
  }
}

export const aiGenerationsService = new AIGenerationsService();